import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import moe_logo from '../assets/moe_logo.png';
import Logo from '../assets/logo_white.png'

import { MdAlternateEmail, MdLock, MdOutlineClose} from "react-icons/md";

import { AppContext } from "../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";
import { Img, Tasks } from "../components/Elements";
import { Input } from "../components/Form";

import './css/Login.css'
import { Config } from '../inc/Config';

export default function Login(props) {
    
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    
	const {successData, userData} = useContext(AppContext); 
	const [open, setopen] = successData;
	const [userinfo, setuserinfo] = userData;

    const [loader, setloader] = useState(false);
    const [values, setvalues] = useState({});
    
    function close() {
        navigate(-1); 
    }

    function login(e) {
        e.preventDefault();

        setloader(true);
        Fetch("login", (d) => {

            if (d?.error) {
                console.log(d?.error, t("error",  { returnObjects: true })[d?.error]);
                
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {
                setuserinfo(d?.userinfo);
                setopen({ error:false, short: t("error",  { returnObjects: true })[14] });
                close();
            }

            setloader(false);
        }, values);
    }

    async function moe_login() {

        window.location= `https://www.yallangany.com/simplesaml/module.php/core/as_login.php?AuthId=default-sp&ReturnTo=https://www.yallangany.com/moeLogin`
        // window.location= `/simplesaml/login.php`
        // let res = await fetch(Config.saml + `login`);
        // let json = await res.json();

        // console.log(json);
        

    }

    useEffect(() => {

		function handleNavigation(e) {
			if(e?.target?.className == 'loginBody') {
				close()
			}
		}

        window.addEventListener("click", handleNavigation);
        return () => {
            window.removeEventListener("click", handleNavigation);
        };

    }, []);
    

	return (
        <>
        {loader && <Loader />}
            <section className="loginBody">

                <div className='loginBox'>
                    <a onClick={close} className='closeLogin'><MdOutlineClose /></a>

                    <div className='right'>

                        <h2>{t("login_title")}<span> {t("login_again")}</span></h2>
                        <p>{t("login_subtitle")}</p>

                        <div className='moeLoginBox'>
                            <button onClick={moe_login} className='btn'><img src={moe_logo} /> {t("login_moe")}</button>
                        </div>

                        
                        <div className='or'>
                            <b>{t("login_or")}</b>
                            <hr />
                        </div>

                        

                        <form onSubmit={login}>
                            <Input
                                title={t("login_username")}
                                icon={<MdAlternateEmail />}
                                onChange={(d) => setvalues(p => ({
                                    ...p,
                                    username:d,
                                }))}
                            />

                            <Input
                                title={t("login_pass")}
                                icon={<MdLock />}
                                type="password"
                                onChange={(d) => setvalues(p => ({
                                    ...p,
                                    password:d,
                                }))}
                            />

                            <div className='forgotPs'>
                                <Link>{t("login_forgot")}</Link>
                            </div>

                            <div className='loginBtnBox'>
                                <button className='btn'>{t("login")}</button>
                            </div>
                        </form>

                        

                    </div>

                    <div className='left'>
                        <img className="logo" src={Logo} /> 
                        <div>
                            <h1>{t("main_title")}</h1>
                            <p>{t("main_subtitle")}</p>
                        </div>
                    </div>

                </div>

            </section>
        </>
	)
}
